import nanoScroller from '@global/vendors/jquery.nanoscroller.min';
import Vue from 'vue';
import cartNotification from '@global/components/cart/cartNotification';
import AlertDialog from '@global/helpers/alertDialog';
import messageBox from '@global/helpers/messageBox';
import NewImage from '@global/components/global/image';
import store from '@global/components/store/index';
import { createNamespacedHelpers } from 'vuex';
import $ from 'jquery';
import globalCtrl from '@page/common/js/globalCtrl';
import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('miniCartModule');

// ! 這個不知道前人留下來幹嘛的，先不要亂拿掉
global.$ = global.jQuery = require('jquery'); // fix can't use JQ in inline script

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.Vue = Vue;
window.messageBox = messageBox;

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

require('sticky-kit/dist/sticky-kit');

const $btnTop = $('#top-btn');

if ($('#app-mini-cart').length > 0) {
  window.appNotificationCart = new Vue({
    el: '#app-mini-cart',
    store,
    components: { NewImage },
    computed: {
      ...mapState([
        'totalCount',
        'generalCount',
        'refrigerationCount',
        'freezingCount',
        'dataIsLoad',
        'generalMarketProducts',
        'count',
        'hotSearch',
        'hotLoad',
      ]),
      ...mapGetters(['isOnlyOneTemp']),
    },
    watch: {
      hotLoad(value) {
        if (value && window.location.pathname.includes('search')) {
          fireSearchListEvent(this.hotSearch);
        }
      },
    },
    created() {
      this.getCartInfo();
      this.getHotSearch();
    },
    methods: {
      ...mapActions(['getCartInfo', 'getHotSearch']),
      customCount(count) {
        if (count < 10) {
          return `0${count.toString()}`;
        }
        return count.toString();
      },
      goSearch(item) {
        window.location.href = `/search?Keyword=${item}`;
        fireSearchEvent({
          isHotSearch: true,
          keyword: item,
        });
      },
      goInputSearch() {
        if ($('.hot-input').val().length === 0) {
          AlertDialog.alert('請輸入文字');
        } else {
          window.location.href = `/search?Keyword=${$('.hot-input').val()}`;
          fireSearchEvent({
            isHotSearch: false,
            keyword: $('.hot-input').val(),
          });
        }
      },
      spread() {
        $('.hot-input-block').addClass('open');
        $('.hot-cancel').css('display', 'inline-block');
      },
      cancel() {
        $('.hot-input-block').removeClass('open');
        $('.hot-cancel').css('display', 'none');
        $('.hot-input').val('');
      },
    },
  });
}

// 電子報
window.RecordNewsletter = function RecordNewsletter() {
  $.ajax({
    type: 'POST',
    url: '/api/v1/Subscribe/Apply',
    dataType: 'json',
    data: { Email: $('#input-newsletter').val() },
    xhrFields: {
      withCredentials: false,
    },
    error() {
      AlertDialog.alert('System busy, please try again error');
    },
    success(res) {
      AlertDialog.alert(res.Message);
    },
  });
};

$(window).scroll(function () {
  if ($('body').attr('id') === 'page-shop' || $('body').attr('id') === 'page-shop-content') {
    if ($(this).scrollTop() > 500) {
      $btnTop.css({ opacity: 1, visibility: 'visible' });
    } else {
      $btnTop.css({ opacity: 0, visibility: 'hidden' });
    }
  }
});

$btnTop.click(function (e) {
  e.preventDefault();
  $('html,body').animate({ scrollTop: 0 }, 300);
  return false;
});

globalCtrl();
